export const COMPANY = {
    name: "Nachi Eng Ltd",
    registration: "16567818",
    incorporated: "July 2025",
    status: "Active",
    location: "Southend-on-Sea, Essex, United Kingdom",
    serviceArea: "London, Essex and the wider South East, with UK projects considered by agreement",
    email: "info@nachieng.co.uk",
    linkedin: "https://www.linkedin.com/company/nachi-eng-ltd",
    calendly: "https://calendly.com/godswill-nachieng/30min",
    responseCommitment: "within two working days",
    canonicalOrigin: "https://www.nachieng.co.uk",
};

export const FOUNDER = {
    name: "Godswill C. Iweajunwa",
    role: "Founder & Director",
};

export const FOUNDER_BIO =
    "A first-class graduate in electrical and electronic engineering and a Member of the Institution of Engineering and Technology, Godswill C. Iweajunwa formed Nachi Eng Ltd in 2025 to bring rigorous, accountable engineering support to industrial environments — and to develop maintenance technology shaped by real maintenance work.";

export const CREDENTIALS = [
    "BEng (Hons) Electrical & Electronic Engineering — First Class",
    "Member of the Institution of Engineering and Technology — MIET",
    "18th Edition electrical qualification",
];

export const EXPERIENCE_STATEMENT =
    "Hands-on industrial maintenance experience across manufacturing and commercial environments.";

export const NAV_LINKS = [
    { label: "Services", to: "/services", testId: "nav-services" },
    { label: "Nachi CMMS", to: "/tmms", testId: "nav-tmms" },
    { label: "Demonstrations", to: "/demonstrations", testId: "nav-demonstrations" },
    { label: "About", to: "/about", testId: "nav-about" },
    { label: "Insights", to: "/insights", testId: "nav-insights" },
];

export const PRIMARY_CTA = {
    label: "Discuss an Engineering Requirement",
    to: "/contact",
    testId: "cta-discuss-requirement",
};

export const SECONDARY_CTA = {
    label: "Explore Nachi CMMS",
    to: "/tmms",
    testId: "cta-explore-tmms",
};

export const INDUSTRIES = [
    { name: "Factories and manufacturing", future: false },
    { name: "Warehouses, logistics and distribution", future: false },
    { name: "Commercial and industrial facilities", future: false },
    { name: "Hotels and hospitality facilities", future: false },
    { name: "Facilities-management environments", future: false },
    { name: "Healthcare estates", future: true },
];

export const ARTICLES = [
    { title: "What is a CMMS?", to: "/insights/what-is-a-cmms" },
    { title: "The 2am Phone Call That's Costing Your Facility a Fortune", to: "/insights/reactive-vs-preventive-maintenance" },
];
